import {
  APP_DETAILS,
  UNSET_APP,
  APP_PRICE,
  APP_AUTHOR,
  APP_PRICE_PENDING_STATUS,
  UPDATE_APP_DETAILS,
  DELETE_APP_COVER,
} from '../../types';

import * as media from './media';
import * as releases from './releases';
import insight from './insight';

import { Apps } from '@/api/api';

const state = () => ({
  app: {},
  ...insight.state(),
  ...media.state(),
  ...releases.state(),
});

export const getters = {
  [APP_DETAILS]({ app }) {
    return app;
  },

  [APP_PRICE]({ app: { price, requestedPrice: requestedPrice } }) {
    return requestedPrice || price;
  },

  [APP_AUTHOR]({ app: { developerTitle } }) {
    return developerTitle;
  },

  [APP_PRICE_PENDING_STATUS]({ app: { hasNewPriceChangeRequest } }) {
    return hasNewPriceChangeRequest;
  },

  ...insight.getters,
  ...media.getters,
  ...releases.getters,
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [APP_DETAILS](stateObj, app) {
    stateObj.app = app;
  },
  [UPDATE_APP_DETAILS](stateObj, partailApp) {
    stateObj.app = { ...stateObj.app, ...partailApp };
  },
  [APP_PRICE](stateObj, price) {
    stateObj.app = {
      ...stateObj.app,
      price,
      requestedPrice: price,
    };
  },

  [APP_AUTHOR](stateObj, developerTitle) {
    stateObj.app = {
      ...stateObj.app,
      developerTitle,
    };
  },

  [APP_PRICE_PENDING_STATUS](stateObj, pricePendingStatus) {
    stateObj.app = {
      ...stateObj.app,
      hasNewPriceChangeRequest: pricePendingStatus,
    };
  },

  [UNSET_APP](stateObj) {
    const initial = state();
    Object.keys(initial).forEach(key => {
      stateObj[key] = initial[key];
    });
  },

  ...insight.mutations,
  ...media.mutations,
  ...releases.mutations,
};

export const actions = {
  [APP_DETAILS]({ commit }, packageName) {
    return Apps.get(packageName)
      .then(app => {
        commit(APP_DETAILS, { ...app });
      })
      .catch(({ message }) => Promise.reject(message));
  },
  [UPDATE_APP_DETAILS]({ commit }, partialApp = {}) {
    commit(UPDATE_APP_DETAILS, partialApp);
  },
  [DELETE_APP_COVER]({ commit }, packageName) {
    return Apps.deleteCover({ packageName }).then(res => {
      commit(UPDATE_APP_DETAILS, { cover: '' });
      return res;
    });
  },

  [UNSET_APP]({ commit }) {
    commit(UNSET_APP);
  },

  ...insight.actions,
  ...media.actions,
  ...releases.actions,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
